import { Paragraph } from 'docx'

const highlights = (highlights: string[]) => {
  if (!highlights?.length) {
    return []
  }
  const bullets = highlights.map(highlight => {
    return new Paragraph({
      text: highlight,
      bullet: {
        level: 0,
      },
    })
  })
  return [
    new Paragraph({
      text: '\n',
    }),
    ...bullets,
  ]
}

export default highlights
